export default __webpack_public_path__ + "static/media/backer-brandmark.0124edc2.svg";